import i18n from "../../../../constants/i18n";
import { SUPERVISE_ADMIN_AUDITS_HEADERS } from "../../../../constants/table-custom-headers/Supervisor";
import getSuperviseStore from "../../../../stores/supervisor-store/supervise-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const AdminEventsToSuperviseData = withLiteObserverAndTheme(() => {
  const auditedEvents =
    getSuperviseStore().auditedEventsToSuperviseOrdered.get();

  return (
    <Et3Table
      columns={SUPERVISE_ADMIN_AUDITS_HEADERS}
      rows={auditedEvents}
      title={i18n.get("EVENTS_COUNT")}
      shouldBeFlagged={false}
      titleKey={"EVENTS_COUNT"}
    />
  );
});

export default AdminEventsToSuperviseData;
